import { render, staticRenderFns } from "./QuoteTemplate.vue?vue&type=template&id=3ad45588&scoped=true&"
import script from "./QuoteTemplate.vue?vue&type=script&lang=js&"
export * from "./QuoteTemplate.vue?vue&type=script&lang=js&"
import style0 from "./QuoteTemplate.vue?vue&type=style&index=0&id=3ad45588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad45588",
  null
  
)

component.options.__file = "QuoteTemplate.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardText,
  VCheckbox,
  VDataTable,
  VDialog,
  VFlex,
  VSpacer,
  VTextField,
  VToolbar,
  VToolbarTitle,
})
